import { Component, OnInit, Input } from '@angular/core';
import { OrderService } from '@app/core/business/order/order.service';
import * as moment from 'moment';

@Component({
  selector: 'app-remaining-time-order',
  templateUrl: './remaining-time-order.component.html',
  styleUrls: ['./remaining-time-order.component.scss'],
})
export class RemainingTimeOrderComponent implements OnInit {
  @Input() validityRate: number;
  @Input() remainingTime: string;
  @Input() mobile = false;
  @Input() validityEndDate: string;
  @Input() cutOffPreco: string;

  public formattedValidityEndDate: string;
  public remainingTimeDuration: string;

  constructor(public orderService: OrderService) { }

  ngOnInit() {
  this.formatValidityEndDate();
  }

  private checkIsPreco(): boolean {
    return this.orderService.isPrecommande === true;
  }

  private formatValidityEndDate(): void {
    if (this.cutOffPreco) {
      const now = moment();
      const endDate = moment.utc(this.validityEndDate).local();
      const duration = moment.duration(endDate.diff(now));
      const term = endDate.diff(now);
      
      const days = duration.days();
      
      const hours = duration.hours() + (days * 24); 
      const minutes = duration.minutes();

      
      this.formattedValidityEndDate = `Préco, date limite validation : ${hours}h${minutes}`;
  }

  }

}